import { lazy, Suspense } from 'react';

const TestLinkComponent = lazy(() =>
  import('./TestLink').then(({ TestLink }) => ({
    default: TestLink,
  })),
);

export function LazyTestLink(): JSX.Element {
  return (
    <Suspense fallback={null}>
      <TestLinkComponent />
    </Suspense>
  );
}
